var data = [
  {
    name: "Home",
    start: "<Home>",
    end: "</Home>",
  },
  {
    name: "About",
    start: "<About>",
    end: "</About>",
  },
  {
    name: "Skills",
    start: "<Skills>",
    end: "</Skills>",
  },
  {
    name: "Projects",
    start: "<Projects>",
    end: "</Projects>",
  },
  {
    name: "Contact",
    start: "<Contact>",
    end: "</Contact>",
  },
];

var div = [
  {
    start: "<div>",
    end: "</div>",
  },
];

export { data, div };
